const ACCESS = "dicole_access_token";
const REFRESH = "dicole_refresh_token";

export function loadStoredTokens(): {
  access: string | null;
  refresh: string | null;
} {
  try {
    return {
      access: localStorage.getItem(ACCESS),
      refresh: localStorage.getItem(REFRESH),
    };
  } catch {
    return { access: null, refresh: null };
  }
}

export function saveStoredTokens(access: string, refresh: string) {
  localStorage.setItem(ACCESS, access);
  localStorage.setItem(REFRESH, refresh);
}

export function clearStoredTokens() {
  localStorage.removeItem(ACCESS);
  localStorage.removeItem(REFRESH);
}
